<div class="container psa-duplicate-container p-3" cdkDrag cdkDragBoundary=".map-frame">
  <!-- Titolo della finestra di dialogo -->
  <div class="d-flex align-items-center justify-content-between gap-2">
    <h4>{{ 'map.sidebar.psa.create_interconnection.title' | translate }}</h4>
    <mat-icon cdkDragHandle aria-label="Drag Handle" style="cursor: grab" class="mb-2">open_with</mat-icon>
  </div>
  <p class="text-muted d-flex justify-content-between">
    <span>{{ 'map.sidebar.psa.create_interconnection.description' | translate }}</span>
  </p>

  <div class="form-group">
    <form [formGroup]="form">
      <!-- NOME INTERCONNESSIONE -->
      <div class="d-flex align-items-center justify-content-start gap-3">
        <mat-form-field appearance="outline" style="width: 90%">
          <mat-label>{{ 'map.sidebar.psa.create_interconnection.form.nome' | translate }}</mat-label>
          <input formControlName="nome" matInput />
          <mat-error *ngIf="form.get('nome')?.hasError('minlength')">Il nome deve contenere almeno 3 caratteri</mat-error>
          <mat-error *ngIf="form.get('nome')?.hasError('required')">Il nome è obbligatorio</mat-error>
        </mat-form-field>

        <mat-icon matTooltip="{{ 'map.sidebar.psa.create_interconnection.form.nome_info' | translate }}">info</mat-icon>
      </div>

      <!-- NODO PARTENZA -->
      <mat-form-field appearance="outline">
        <mat-label>{{ 'map.sidebar.psa.create_interconnection.form.start_node' | translate }}</mat-label>
        <input type="text" matInput formControlName="startNode" [matAutocomplete]="autoCampo1" [placeholder]="'map.sidebar.psa.search' | translate" />
        <mat-autocomplete #autoCampo1="matAutocomplete">
          <mat-option *ngFor="let result of searchResultsCampo1" [value]="result.search_term" (click)="onItemSelect(result.search_term, 'startNode')">
            {{ result.search_term }}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="form.get('startNode').hasError('optionError')">
          <ng-container *ngTemplateOutlet="errorOption"></ng-container>
        </mat-error>
        <mat-error *ngIf="form.get('startNode').hasError('required')">
          <ng-container *ngTemplateOutlet="errorRequired"></ng-container>
        </mat-error>
        <mat-error *ngIf="form.get('startNode').hasError('queryError')">
          <ng-container *ngTemplateOutlet="errorQuery"></ng-container>
        </mat-error>
      </mat-form-field>

      <!-- NODO ARRIVO  -->
      <mat-form-field appearance="outline">
        <mat-label>{{ 'map.sidebar.psa.create_interconnection.form.end_node' | translate }}</mat-label>
        <input type="text" matInput formControlName="endNode" [matAutocomplete]="autoCampo2" [placeholder]="'map.sidebar.psa.search' | translate" />
        <mat-autocomplete #autoCampo2="matAutocomplete">
          <mat-option *ngFor="let result of searchResultsCampo2" [value]="result.search_term" (click)="onItemSelect(result.search_term, 'endNode')">
            {{ result.search_term }}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="form.get('endNode').hasError('optionError')">
          <ng-container *ngTemplateOutlet="errorOption"></ng-container>
        </mat-error>
        <mat-error *ngIf="form.get('endNode').hasError('required')">
          <ng-container *ngTemplateOutlet="errorRequired"></ng-container>
        </mat-error>
        <mat-error *ngIf="form.get('endNode').hasError('queryError')">
          <ng-container *ngTemplateOutlet="errorQuery"></ng-container>
        </mat-error>
      </mat-form-field>
    </form>
  </div>

  <!-- Pulsanti di azione -->
  <div class="d-flex justify-content-end mt-5 gap-3">
    <button mat-button color="warn" (click)="closeModal()">{{ 'map.sidebar.psa.create_interconnection.form.close' | translate }}</button>
    <button mat-raised-button color="primary" [disabled]="form.invalid" (click)="saveInterconnection()">
      {{ 'map.sidebar.psa.create_interconnection.form.save' | translate }}
    </button>
  </div>
</div>

<ng-template #errorRequired>{{ 'map.sidebar.psa.create_interconnection.form.errors.error_required' | translate }}</ng-template>
<ng-template #errorQuery>{{ 'map.sidebar.psa.create_interconnection.form.errors.error_query' | translate }}</ng-template>
<ng-template #errorOption>{{ 'map.sidebar.psa.create_interconnection.form.errors.error_option' | translate }}</ng-template>
